export default __webpack_public_path__ + "static/media/search-icon.eabb8e91.svg";